import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import React from 'react'
import useCustomerImportRowLimit from './useCustomerImportRowLimit'

const t = buildTranslate('user_lists.import_row_limit')

type Props = {
  className?: string
}

const ImportRowLimitNote: React.FC<Props> = ({ className }) => {
  const limit = useCustomerImportRowLimit()
  return (
    <Text.BodyText4 color="grey70" tag="p" className={className}>
      {t('note', { limit: limit.toLocaleString() })}
    </Text.BodyText4>
  )
}

export default ImportRowLimitNote
